import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import LinkMUI from '@mui/material/Link'
import MailIcon from '@mui/icons-material/Mail'
import { useIsMerchant } from '../../../config/utils/RolesUtils'
import { getCommercial } from '../../../api/pntagent.api'
import { useTheme } from '@mui/material'
import profileConfig from '@/config/constants/profile/config_pontio.js'

const HeaderMail = ({ user }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isMerchant = useIsMerchant()

  const [mailPop, setMailPop] = useState(false)
  const [commercial, setCommercial] = useState({})
  const mail = profileConfig.supportMail

  const handleMail = () => {
    if (isMerchant) {
      getCommercial()
        .then((response) => {
          setCommercial(response.data)
        })
        .catch(() => setCommercial({}))
    }
    setMailPop(true)
  }

  return (
    <LinkMUI>
      <MenuItem onClick={handleMail}>
        <ListItemIcon>
          <MailIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('HEADER.MAIL')} />
      </MenuItem>
      <Dialog
        onClose={() => setMailPop(false)}
        open={mailPop}
        slotProps={{ paper: { style: { borderRadius: '0.375rem' } } }}
        style={{
          borderRadius: '0.375rem',
          boxShadow: theme.customShadows.medium,
        }}>
        <Grid container style={{ backgroundColor: theme.palette.background.primary.color }}>
          <Grid size={12}>
            <Typography
              style={{
                color: theme.palette.text.light.color,
                textDecoration: 'underline',
                paddingLeft: '2rem',
                paddingTop: '1rem',
              }}
              variant="h5">
              {t('HEADER.MAIL')}
            </Typography>
          </Grid>
          <Grid size={12} style={{ padding: '1rem 2rem' }}>
            <Typography align="justify" style={{ color: theme.palette.text.light.color }}>
              {t('HEADER.SEND.TEXT')} <b>{commercial?.iduser?.email ? commercial?.iduser?.email : mail}</b>
            </Typography>
          </Grid>
        </Grid>
        <Divider
          style={{
            backgroundColor: theme.palette.background.primaryLight.color,
            height: '0.0625rem',
          }}
          flexItem
        />
        <Grid style={{ backgroundColor: theme.palette.background.primary.color }}>
          <LinkMUI
            style={{ color: 'white' }}
            href={
              'mailto:' + commercial?.iduser?.email
                ? commercial?.iduser?.email
                : mail + '?Subject=' + t('HEADER.SUBJECTMAIL') + user.name
            }
            underline="hover">
            <Typography
              style={{
                height: '3rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: theme.palette.text.light.color,
              }}>
              <MailIcon style={{ marginRight: '4px' }} fontSize="medium" />
              {t('HEADER.SEND')}
            </Typography>
          </LinkMUI>
        </Grid>
      </Dialog>
    </LinkMUI>
  )
}

export default HeaderMail
